import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';

@Component({
    selector: 'app-payment-details',
    templateUrl: './knetPaymentDetails.page.html',
    styleUrls: ['./knetPaymentDetails.page.scss'],
})
export class knetPaymentDetailsPage implements OnInit {

    titleContent: any;
    messageContent: any;
    messageTicket: any;
    messageModel: any;
    typeValue: any;
    dateTime: any;

    constructor(public modalCtrl: ModalController, public navParams: NavParams,public addCall: AddCall) {

        this.messageContent = navParams.get('messageContent');
        this.messageTicket = navParams.get('messageTicket');
        this.messageModel = navParams.get('messageModel');
        this.titleContent = navParams.get('titleContent');
        this.typeValue = navParams.get('typeValue');

        console.log("knet success details" + " " + this.messageContent);
        console.log("knet success details" + " " + JSON.stringify(this.messageContent));

        this.dateTime = this.formatDate(new Date());
        console.log(this.dateTime);
    }

    formatDate(date: Date): string {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear().toString();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

    ngOnInit() {

    }

    dismiss(type) {
        this.modalCtrl.dismiss(type);
    }

    proceedLogout() {
        this.modalCtrl.dismiss({ status: 5 });
    }

    closemodel() {
        this.modalCtrl.dismiss();
    }
}
